﻿class SelectLabel {
    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }

    render(el, index) {
        var showClass = "floatl--active";
        var $label = $(el);
        var $select = $(el).find('select');

        $select.bind("checkval", function () {
            if (this.value !== "")
                $label.addClass(showClass);
            else
                $label.removeClass(showClass);
            }).trigger("checkval");

        $select.on("change", function () {
                var $this = $(this);
                $this.trigger("checkval");
            })
            .change();
    }
}

export default SelectLabel;